import { render } from "./PublicPlaceholderView.vue?vue&type=template&id=00ad577c"
import script from "./PublicPlaceholderView.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./PublicPlaceholderView.vue?vue&type=script&charset=utf-8&lang=js"

import "./PublicPlaceholderView.vue?vue&type=style&index=0&id=00ad577c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__